import logo from "./images/icon-N.png";
import overallmarket from './images/overallmarket.png';
import bluechip from './images/bluechip.png';
import Top100 from './images/Top100.png';
import metaverse from './images/metaverse.png';
import play2earn from './images/play2earn.png';
import utility from './images/utility.png';
import passes from './images/passes.png';
import dao from './images/dao.png';
import pfp from './images/pfp.png';
import appcoin from './images/appcoin.png';
import meebits from './images/meebits.png';
import mask from './images/mask.png';
import mask2 from './images/mask2.png';
import crypto from './images/crypto.png';
import setting from './images/setting.png';
import nftimg from './images/nftimg.png';
import newNoProfile from './images/newNoProfile.png';

const imageNftMarket = [
    overallmarket,
    bluechip,
    Top100,
    metaverse,
    play2earn,
    utility,
    passes,
    dao,
    pfp

];
 
export default {
    logo,
    newNoProfile,
    imageNftMarket,
    appcoin,
    meebits,
    mask,
    mask2,
    crypto,
    setting,
    nftimg
}